// Generated by `bun run --filter @esi/shared catalogue:sync` (scripts/catalogue-sync.ts):
// do not edit. From @opencode-ai/models@0.0.119, snapshot 2026-10-29T05:26:25.333Z: every
// Bedrock route of the served labs with a profile in a served geography (model-picking D3).
// Model metadata from models.dev (https://models.dev), licence in canonical.generated.ts.
import type { GeneratedOffering } from "./offerings.ts";

export const GENERATED_OFFERINGS = {
  "amazon.nova-2-lite-v1:0": {
    canonical: "amazon/nova-2-lite",
    displayName: "Nova 2 Lite",
    routes: {
      foundation: "amazon.nova-2-lite-v1:0",
      profiles: {
        eu: "eu.amazon.nova-2-lite-v1:0",
        global: "global.amazon.nova-2-lite-v1:0",
      },
    },
    price: {
      foundation: {
        input: 0.33,
        output: 2.75,
        cacheRead: 0.0825,
        cacheWrite: 0.33,
      },
      eu: {
        input: 0.374,
        output: 3.157,
        cacheRead: 0.0935,
        cacheWrite: 0.374,
      },
      global: {
        input: 0.3,
        output: 2.5,
        cacheRead: 0.075,
        cacheWrite: 0.3,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "amazon.nova-lite-v1:0": {
    canonical: "amazon/nova-lite",
    displayName: "Nova Lite",
    routes: {
      foundation: "amazon.nova-lite-v1:0",
      profiles: {
        eu: "eu.amazon.nova-lite-v1:0",
      },
    },
    price: {
      foundation: {
        input: 0.06,
        output: 0.24,
        cacheRead: 0.015,
        cacheWrite: 0.06,
      },
      eu: {
        input: 0.069,
        output: 0.276,
        cacheRead: 0.01725,
        cacheWrite: 0.069,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "amazon.nova-micro-v1:0": {
    canonical: "amazon/nova-micro",
    displayName: "Nova Micro",
    routes: {
      foundation: "amazon.nova-micro-v1:0",
      profiles: {
        eu: "eu.amazon.nova-micro-v1:0",
      },
    },
    price: {
      foundation: {
        input: 0.035,
        output: 0.14,
        cacheRead: 0.00875,
        cacheWrite: 0.035,
      },
      eu: {
        input: 0.04,
        output: 0.16,
        cacheRead: 0.01,
        cacheWrite: 0.04,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "amazon.nova-pro-v1:0": {
    canonical: "amazon/nova-pro",
    displayName: "Nova Pro",
    routes: {
      foundation: "amazon.nova-pro-v1:0",
      profiles: {
        eu: "eu.amazon.nova-pro-v1:0",
      },
    },
    price: {
      foundation: {
        input: 0.8,
        output: 3.2,
        cacheRead: 0.2,
        cacheWrite: 0.8,
      },
      eu: {
        input: 0.92,
        output: 3.68,
        cacheRead: 0.23,
        cacheWrite: 0.92,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "anthropic.claude-fable-5": {
    canonical: "anthropic/claude-fable-5",
    displayName: "Claude Fable 5",
    routes: {
      foundation: "anthropic.claude-fable-5",
      profiles: {
        eu: "eu.anthropic.claude-fable-5",
        global: "global.anthropic.claude-fable-5",
      },
    },
    price: {
      foundation: {
        input: 10,
        output: 50,
        cacheRead: 1,
        cacheWrite: 12.5,
      },
      eu: {
        input: 11,
        output: 55,
        cacheRead: 1.1,
        cacheWrite: 13.75,
      },
      global: {
        input: 10,
        output: 50,
        cacheRead: 1,
        cacheWrite: 12.5,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "anthropic.claude-fable-5-1": {
    canonical: "anthropic/claude-fable-5-1",
    displayName: "Claude Fable 5.1",
    routes: {
      foundation: "anthropic.claude-fable-5-1",
      profiles: {
        global: "global.anthropic.claude-fable-5-1",
      },
    },
    price: {
      foundation: {
        input: 10,
        output: 50,
        cacheRead: 0.25,
        cacheWrite: 12.5,
      },
      global: {
        input: 10,
        output: 50,
        cacheRead: 0.25,
        cacheWrite: 12.5,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "anthropic.claude-haiku-4-5-20251001-v1:0": {
    canonical: "anthropic/claude-haiku-4-5-20251001",
    displayName: "Claude Haiku 4.5",
    routes: {
      foundation: "anthropic.claude-haiku-4-5-20251001-v1:0",
      profiles: {
        eu: "eu.anthropic.claude-haiku-4-5-20251001-v1:0",
        global: "global.anthropic.claude-haiku-4-5-20251001-v1:0",
      },
    },
    price: {
      foundation: {
        input: 1,
        output: 5,
        cacheRead: 0.1,
        cacheWrite: 1.25,
      },
      eu: {
        input: 1.1,
        output: 5.5,
        cacheRead: 0.11,
        cacheWrite: 1.375,
      },
      global: {
        input: 1,
        output: 5,
        cacheRead: 0.1,
        cacheWrite: 1.25,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "anthropic.claude-haiku-5-5": {
    canonical: "anthropic/claude-haiku-5-5",
    displayName: "Claude Haiku 5.5",
    routes: {
      foundation: "anthropic.claude-haiku-5-5",
      profiles: {
        eu: "eu.anthropic.claude-haiku-5-5",
        global: "global.anthropic.claude-haiku-5-5",
      },
    },
    price: {
      foundation: {
        input: 0.1,
        output: 0.5,
        cacheRead: 0.01,
        cacheWrite: 0.125,
        tiers: [
          {
            contextSize: 100000,
            input: 0.5,
            output: 2.5,
            cacheRead: 0.05,
            cacheWrite: 0.625,
          },
        ],
      },
      eu: {
        input: 0.11,
        output: 0.55,
        cacheRead: 0.011,
        cacheWrite: 0.1375,
        tiers: [
          {
            contextSize: 100000,
            input: 0.55,
            output: 2.75,
            cacheRead: 0.055,
            cacheWrite: 0.6875,
          },
        ],
      },
      global: {
        input: 0.1,
        output: 0.5,
        cacheRead: 0.01,
        cacheWrite: 0.125,
        tiers: [
          {
            contextSize: 100000,
            input: 0.5,
            output: 2.5,
            cacheRead: 0.05,
            cacheWrite: 0.625,
          },
        ],
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "anthropic.claude-opus-4-5-20251101-v1:0": {
    canonical: "anthropic/claude-opus-4-5-20251101",
    displayName: "Claude Opus 4.5",
    routes: {
      foundation: "anthropic.claude-opus-4-5-20251101-v1:0",
      profiles: {
        eu: "eu.anthropic.claude-opus-4-5-20251101-v1:0",
        global: "global.anthropic.claude-opus-4-5-20251101-v1:0",
      },
    },
    price: {
      foundation: {
        input: 5,
        output: 25,
        cacheRead: 0.5,
        cacheWrite: 6.25,
      },
      eu: {
        input: 5.5,
        output: 27.5,
        cacheRead: 0.55,
        cacheWrite: 6.875,
      },
      global: {
        input: 5,
        output: 25,
        cacheRead: 0.5,
        cacheWrite: 6.25,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "anthropic.claude-opus-4-6-v1": {
    canonical: "anthropic/claude-opus-4-6",
    displayName: "Claude Opus 4.6",
    routes: {
      foundation: "anthropic.claude-opus-4-6-v1",
      profiles: {
        eu: "eu.anthropic.claude-opus-4-6-v1",
        global: "global.anthropic.claude-opus-4-6-v1",
      },
    },
    price: {
      foundation: {
        input: 5.5,
        output: 27.5,
        cacheRead: 0.55,
        cacheWrite: 6.875,
      },
      eu: {
        input: 5.5,
        output: 27.5,
        cacheRead: 0.55,
        cacheWrite: 6.875,
      },
      global: {
        input: 5,
        output: 25,
        cacheRead: 0.5,
        cacheWrite: 6.25,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "anthropic.claude-opus-4-7": {
    canonical: "anthropic/claude-opus-4-7",
    displayName: "Claude Opus 4.7",
    routes: {
      foundation: "anthropic.claude-opus-4-7",
      profiles: {
        eu: "eu.anthropic.claude-opus-4-7",
        global: "global.anthropic.claude-opus-4-7",
      },
    },
    price: {
      foundation: {
        input: 5,
        output: 25,
        cacheRead: 0.5,
        cacheWrite: 6.25,
      },
      eu: {
        input: 5.5,
        output: 27.5,
        cacheRead: 0.55,
        cacheWrite: 6.875,
      },
      global: {
        input: 5,
        output: 25,
        cacheRead: 0.5,
        cacheWrite: 6.25,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "anthropic.claude-opus-4-8": {
    canonical: "anthropic/claude-opus-4-8",
    displayName: "Claude Opus 4.8",
    routes: {
      foundation: "anthropic.claude-opus-4-8",
      profiles: {
        eu: "eu.anthropic.claude-opus-4-8",
        global: "global.anthropic.claude-opus-4-8",
      },
    },
    price: {
      foundation: {
        input: 5,
        output: 25,
        cacheRead: 0.5,
        cacheWrite: 6.25,
      },
      eu: {
        input: 5.5,
        output: 27.5,
        cacheRead: 0.55,
        cacheWrite: 6.875,
      },
      global: {
        input: 5,
        output: 25,
        cacheRead: 0.5,
        cacheWrite: 6.25,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "anthropic.claude-opus-5": {
    canonical: "anthropic/claude-opus-5",
    displayName: "Claude Opus 5",
    routes: {
      foundation: "anthropic.claude-opus-5",
      profiles: {
        eu: "eu.anthropic.claude-opus-5",
        global: "global.anthropic.claude-opus-5",
      },
    },
    price: {
      foundation: {
        input: 5,
        output: 25,
        cacheRead: 0.5,
        cacheWrite: 6.25,
      },
      eu: {
        input: 5.5,
        output: 27.5,
        cacheRead: 0.55,
        cacheWrite: 6.875,
      },
      global: {
        input: 5,
        output: 25,
        cacheRead: 0.5,
        cacheWrite: 6.25,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "anthropic.claude-opus-5-5": {
    canonical: "anthropic/claude-opus-5-5",
    displayName: "Claude Opus 5.5",
    routes: {
      foundation: "anthropic.claude-opus-5-5",
      profiles: {
        eu: "eu.anthropic.claude-opus-5-5",
        global: "global.anthropic.claude-opus-5-5",
      },
    },
    price: {
      foundation: {
        input: 4,
        output: 20,
        cacheRead: 0.2,
        cacheWrite: 5,
      },
      eu: {
        input: 4.4,
        output: 22,
        cacheRead: 0.22,
        cacheWrite: 5.5,
      },
      global: {
        input: 4,
        output: 20,
        cacheRead: 0.2,
        cacheWrite: 5,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "anthropic.claude-sonnet-4-20250514-v1:0": {
    canonical: "anthropic/claude-sonnet-4-20250514",
    displayName: "Claude Sonnet 4",
    routes: {
      foundation: "anthropic.claude-sonnet-4-20250514-v1:0",
      profiles: {
        eu: "eu.anthropic.claude-sonnet-4-20250514-v1:0",
        global: "global.anthropic.claude-sonnet-4-20250514-v1:0",
      },
    },
    price: {
      eu: {
        input: 3,
        output: 15,
        cacheRead: 0.3,
        cacheWrite: 3.75,
      },
      global: {
        input: 3,
        output: 15,
        cacheRead: 0.3,
        cacheWrite: 3.75,
      },
    },
    lifecycle: {
      status: "deprecated",
      since: "2026-10-28",
    },
  },
  "anthropic.claude-sonnet-4-5-20250929-v1:0": {
    canonical: "anthropic/claude-sonnet-4-5-20250929",
    displayName: "Claude Sonnet 4.5",
    routes: {
      foundation: "anthropic.claude-sonnet-4-5-20250929-v1:0",
      profiles: {
        eu: "eu.anthropic.claude-sonnet-4-5-20250929-v1:0",
        global: "global.anthropic.claude-sonnet-4-5-20250929-v1:0",
      },
    },
    price: {
      foundation: {
        input: 3,
        output: 15,
        cacheRead: 0.3,
        cacheWrite: 3.75,
      },
      eu: {
        input: 3.3,
        output: 16.5,
        cacheRead: 0.33,
        cacheWrite: 4.125,
      },
      global: {
        input: 3,
        output: 15,
        cacheRead: 0.3,
        cacheWrite: 3.75,
      },
    },
    lifecycle: {
      status: "deprecated",
      since: "2026-10-28",
    },
  },
  "anthropic.claude-sonnet-4-6": {
    canonical: "anthropic/claude-sonnet-4-6",
    displayName: "Claude Sonnet 4.6",
    routes: {
      foundation: "anthropic.claude-sonnet-4-6",
      profiles: {
        eu: "eu.anthropic.claude-sonnet-4-6",
        global: "global.anthropic.claude-sonnet-4-6",
      },
    },
    price: {
      foundation: {
        input: 3.3,
        output: 16.5,
        cacheRead: 0.33,
        cacheWrite: 4.125,
      },
      eu: {
        input: 3.3,
        output: 16.5,
        cacheRead: 0.33,
        cacheWrite: 4.125,
      },
      global: {
        input: 3,
        output: 15,
        cacheRead: 0.3,
        cacheWrite: 3.75,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "anthropic.claude-sonnet-5": {
    canonical: "anthropic/claude-sonnet-5",
    displayName: "Claude Sonnet 5",
    routes: {
      foundation: "anthropic.claude-sonnet-5",
      profiles: {
        eu: "eu.anthropic.claude-sonnet-5",
        global: "global.anthropic.claude-sonnet-5",
      },
    },
    price: {
      foundation: {
        input: 2,
        output: 10,
        cacheRead: 0.2,
        cacheWrite: 2.5,
      },
      eu: {
        input: 2.2,
        output: 11,
        cacheRead: 0.22,
        cacheWrite: 2.75,
      },
      global: {
        input: 2,
        output: 10,
        cacheRead: 0.2,
        cacheWrite: 2.5,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "anthropic.claude-sonnet-5-5": {
    canonical: "anthropic/claude-sonnet-5-5",
    displayName: "Claude Sonnet 5.5",
    routes: {
      foundation: "anthropic.claude-sonnet-5-5",
      profiles: {
        eu: "eu.anthropic.claude-sonnet-5-5",
        global: "global.anthropic.claude-sonnet-5-5",
      },
    },
    price: {
      foundation: {
        input: 2,
        output: 10,
        cacheRead: 0.1,
        cacheWrite: 2.5,
      },
      eu: {
        input: 2.2,
        output: 11,
        cacheRead: 0.11,
        cacheWrite: 2.75,
      },
      global: {
        input: 2,
        output: 10,
        cacheRead: 0.1,
        cacheWrite: 2.5,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "mistral.pixtral-large-2502-v1:0": {
    canonical: "mistral/pixtral-large-2502",
    displayName: "Pixtral Large (25.02)",
    routes: {
      foundation: "mistral.pixtral-large-2502-v1:0",
      profiles: {
        eu: "eu.mistral.pixtral-large-2502-v1:0",
      },
    },
    price: {
      foundation: {
        input: 2,
        output: 6,
      },
      eu: {
        input: 2,
        output: 6,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "moonshotai.kimi-k3": {
    canonical: "moonshotai/kimi-k3",
    displayName: "Kimi K3",
    routes: {
      foundation: "moonshotai.kimi-k3",
      profiles: {
        global: "global.moonshotai.kimi-k3",
      },
    },
    price: {
      global: {
        input: 3,
        output: 15,
        cacheRead: 0.3,
        cacheWrite: 3.75,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "openai.gpt-5.6-luna": {
    canonical: "openai/gpt-5.6-luna",
    displayName: "GPT-5.6 Luna",
    routes: {
      foundation: "openai.gpt-5.6-luna",
      profiles: {
        global: "global.openai.gpt-5.6-luna",
      },
    },
    price: {
      foundation: {
        input: 0.22,
        output: 1.32,
        cacheRead: 0.022,
        cacheWrite: 0.275,
        tiers: [
          {
            contextSize: 272000,
            input: 0.44,
            output: 1.98,
            cacheRead: 0.044,
            cacheWrite: 0.55,
          },
        ],
      },
      global: {
        input: 0.2,
        output: 1.2,
        cacheRead: 0.02,
        cacheWrite: 0.25,
        tiers: [
          {
            contextSize: 272000,
            input: 0.4,
            output: 1.8,
            cacheRead: 0.04,
            cacheWrite: 0.5,
          },
        ],
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "openai.gpt-5.6-sol": {
    canonical: "openai/gpt-5.6-sol",
    displayName: "GPT-5.6 Sol",
    routes: {
      foundation: "openai.gpt-5.6-sol",
      profiles: {
        global: "global.openai.gpt-5.6-sol",
      },
    },
    price: {
      foundation: {
        input: 4.4,
        output: 22,
        cacheRead: 0.44,
        cacheWrite: 5.5,
        tiers: [
          {
            contextSize: 272000,
            input: 8.8,
            output: 33,
            cacheRead: 0.88,
            cacheWrite: 11,
          },
        ],
      },
      global: {
        input: 4,
        output: 20,
        cacheRead: 0.4,
        cacheWrite: 5,
        tiers: [
          {
            contextSize: 272000,
            input: 8,
            output: 30,
            cacheRead: 0.8,
            cacheWrite: 10,
          },
        ],
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "openai.gpt-5.6-terra": {
    canonical: "openai/gpt-5.6-terra",
    displayName: "GPT-5.6 Terra",
    routes: {
      foundation: "openai.gpt-5.6-terra",
      profiles: {
        global: "global.openai.gpt-5.6-terra",
      },
    },
    price: {
      foundation: {
        input: 2.2,
        output: 13.2,
        cacheRead: 0.22,
        cacheWrite: 2.75,
        tiers: [
          {
            contextSize: 272000,
            input: 4.4,
            output: 19.8,
            cacheRead: 0.44,
            cacheWrite: 5.5,
          },
        ],
      },
      global: {
        input: 2,
        output: 12,
        cacheRead: 0.2,
        cacheWrite: 2.5,
        tiers: [
          {
            contextSize: 272000,
            input: 4,
            output: 18,
            cacheRead: 0.4,
            cacheWrite: 5,
          },
        ],
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "openai.gpt-6-astra": {
    canonical: "openai/gpt-6-astra",
    displayName: "GPT-6 Astra",
    routes: {
      foundation: "openai.gpt-6-astra",
      profiles: {
        global: "global.openai.gpt-6-astra",
      },
    },
    price: {
      foundation: {
        input: 11,
        output: 55,
        cacheRead: 1.1,
        cacheWrite: 13.75,
        tiers: [
          {
            contextSize: 272000,
            input: 22,
            output: 82.5,
            cacheRead: 2.2,
            cacheWrite: 27.5,
          },
        ],
      },
      global: {
        input: 10,
        output: 50,
        cacheRead: 1,
        cacheWrite: 12.5,
        tiers: [
          {
            contextSize: 272000,
            input: 20,
            output: 75,
            cacheRead: 2,
            cacheWrite: 25,
          },
        ],
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "openai.gpt-6-luna": {
    canonical: "openai/gpt-6-luna",
    displayName: "GPT-6 Luna",
    routes: {
      foundation: "openai.gpt-6-luna",
      profiles: {
        global: "global.openai.gpt-6-luna",
      },
    },
    price: {
      foundation: {
        input: 0.11,
        output: 0.55,
        cacheRead: 0.011,
        cacheWrite: 0.1375,
        tiers: [
          {
            contextSize: 272000,
            input: 0.22,
            output: 0.825,
            cacheRead: 0.022,
            cacheWrite: 0.275,
          },
        ],
      },
      global: {
        input: 0.1,
        output: 0.5,
        cacheRead: 0.01,
        cacheWrite: 0.125,
        tiers: [
          {
            contextSize: 272000,
            input: 0.2,
            output: 0.75,
            cacheRead: 0.02,
            cacheWrite: 0.25,
          },
        ],
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "openai.gpt-6-sol": {
    canonical: "openai/gpt-6-sol",
    displayName: "GPT-6 Sol",
    routes: {
      foundation: "openai.gpt-6-sol",
      profiles: {
        global: "global.openai.gpt-6-sol",
      },
    },
    price: {
      foundation: {
        input: 2.2,
        output: 11,
        cacheRead: 0.22,
        cacheWrite: 2.75,
        tiers: [
          {
            contextSize: 272000,
            input: 4.4,
            output: 16.5,
            cacheRead: 0.44,
            cacheWrite: 5.5,
          },
        ],
      },
      global: {
        input: 2,
        output: 10,
        cacheRead: 0.2,
        cacheWrite: 2.5,
        tiers: [
          {
            contextSize: 272000,
            input: 4,
            output: 15,
            cacheRead: 0.4,
            cacheWrite: 5,
          },
        ],
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "openai.gpt-6.1-sol": {
    canonical: "openai/gpt-6.1-sol",
    displayName: "GPT-6.1 Sol",
    routes: {
      foundation: "openai.gpt-6.1-sol",
      profiles: {
        global: "global.openai.gpt-6.1-sol",
      },
    },
    price: {
      foundation: {
        input: 2.2,
        output: 11,
        cacheRead: 0.11,
        cacheWrite: 2.75,
        tiers: [
          {
            contextSize: 272000,
            input: 4.4,
            output: 16.5,
            cacheRead: 0.22,
            cacheWrite: 5.5,
          },
        ],
      },
      global: {
        input: 2,
        output: 10,
        cacheRead: 0.1,
        cacheWrite: 2.5,
        tiers: [
          {
            contextSize: 272000,
            input: 4,
            output: 15,
            cacheRead: 0.2,
            cacheWrite: 5,
          },
        ],
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "openai.gpt-6.1-terra": {
    canonical: "openai/gpt-6.1-terra",
    displayName: "GPT-6.1 Terra",
    routes: {
      foundation: "openai.gpt-6.1-terra",
      profiles: {
        global: "global.openai.gpt-6.1-terra",
      },
    },
    price: {
      foundation: {
        input: 1.1,
        output: 5.5,
        cacheRead: 0.055,
        cacheWrite: 1.375,
        tiers: [
          {
            contextSize: 272000,
            input: 2.2,
            output: 8.25,
            cacheRead: 0.11,
            cacheWrite: 2.75,
          },
        ],
      },
      global: {
        input: 1,
        output: 5,
        cacheRead: 0.05,
        cacheWrite: 1.25,
        tiers: [
          {
            contextSize: 272000,
            input: 2,
            output: 7.5,
            cacheRead: 0.1,
            cacheWrite: 2.5,
          },
        ],
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "xai.grok-4.6": {
    canonical: "xai/grok-4.6",
    displayName: "Grok 4.6",
    routes: {
      foundation: "xai.grok-4.6",
      profiles: {
        global: "global.xai.grok-4.6",
      },
    },
    price: {
      foundation: {
        input: 2.2,
        output: 6.6,
        cacheRead: 0.55,
      },
      global: {
        input: 2,
        output: 6,
        cacheRead: 0.5,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "xai.grok-4.7": {
    canonical: "xai/grok-4.7",
    displayName: "Grok 4.7",
    routes: {
      foundation: "xai.grok-4.7",
      profiles: {
        global: "global.xai.grok-4.7",
      },
    },
    price: {
      global: {
        input: 2,
        output: 6,
        cacheRead: 0.5,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
  "zai.glm-5.3": {
    canonical: "zhipuai/glm-5.3",
    displayName: "GLM-5.3",
    routes: {
      foundation: "zai.glm-5.3",
      profiles: {
        global: "global.zai.glm-5.3",
      },
    },
    price: {
      global: {
        input: 1.68,
        output: 5.28,
        cacheRead: 0.312,
        cacheWrite: 2.1,
      },
    },
    lifecycle: {
      status: "active",
    },
  },
} as const satisfies Record<string, GeneratedOffering>;
